import * as React from 'react';

import { observer } from 'mobx-react';
import styled from 'styled-components';

import { ILoyaltyHeroSection } from './ILoyaltyHeroSection';
import { classes } from '~utils/Classes';
import { marketingPageSections as ms } from '~views/marketing-page/sections';

const HeroSectionWrapper = styled.div<{
    logoPosition: number;
    backgroundColor: string;
    imgUrl: string;
}>`
    grid-area: ${ms.heroSection};
    background-color: ${({ backgroundColor }) => `#${backgroundColor}`};
    background-image: url('${({ imgUrl }) => `${imgUrl}`}');
`;

const HeroSectionLogoWrapper = styled.div``;

const HeroSectionTextLinesWrapper = styled.div``;

export const TEST_ID_HERO_SECTION = 'loyalty-marketing-page-hero-section';
const heroSectionClass = classes('hero-section');
const heroSectionLogoClass = classes('hero-section-logo');
const heroSectionImageLogoClass = classes('hero-section-logo__image');
const heroSectionTextLinesClass = classes('hero-section-text-lines');

export const HeroSection = observer(function HeroSection({ heroSection }: ILoyaltyHeroSection) {
    const classNames = `${heroSectionClass}`;
    const imageUrl = heroSection.loyaltyHeroSectionBackground.src ? heroSection.loyaltyHeroSectionBackground.src : '';

    return (
        <>
            <HeroSectionWrapper
                className={classNames}
                data-test-id={TEST_ID_HERO_SECTION}
                logoPosition={heroSection.loyaltyHeroLogoPosition}
                backgroundColor={heroSection.loyaltyHeroSectionBackground.hex}
                imgUrl={imageUrl}
            >
                <HeroSectionLogoWrapper className={heroSectionLogoClass}>
                    <img
                        className={heroSectionImageLogoClass}
                        src={heroSection.loyaltyHeroLogo.src}
                        alt={heroSection.loyaltyHeroLogo.alt}
                    />
                </HeroSectionLogoWrapper>
                <HeroSectionTextLinesWrapper className={heroSectionTextLinesClass}>
                    {heroSection.textLines.map(({ textLine }, index) => (
                        <p key={textLine}>{textLine}</p>
                    ))}
                </HeroSectionTextLinesWrapper>
            </HeroSectionWrapper>
        </>
    );
});
